import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { connect } from 'react-redux';
import Authentication from '../../session';
import withRouter from '../../lib/withRouter';
import Service from '../../../services';
import { baseUrlAdmin } from '../../../store/apiConstants';
import { getBoardsData, getBranchesLatest } from '../../../store/actions';
import { userAssignedBoards } from '../../../store/selectors/userAssignedBoards';
import BoardToSectionDDNew from '../../BaseDropdownComponents/BoardToSectionDDNew';
import LoadingComponent from '../../loadingComponent';

class AssignExamToStudents extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selectedStudents: [],
            categoryAssignInfo: [],
            selectAll: false,
            allRowsSelected: false,
            dropdownsData: null,
            preSelectedIds: [],
            currentPage: 0,
            rowsPerPage: 10
        };
        this.service = new Service();
    }

    componentDidMount() {
        this.props.getBoardsData(true);
        this.props.getBranchesLatest(true);

        // Pre-select items if exam was previously assigned
        const { examination } = this.props;
        if (examination?.assignedTo?.length > 0) {
            this.loadPreviousAssignments();
        }
    }

    componentDidUpdate(prevProps) {
        // If boards data just loaded
        if (!prevProps.boards?.length && this.props.boards?.length > 0) {
            // Initialize dropdowns with provided values
            if (this.props.boardId && this.props.classId) {
                // Data will be loaded when dropdown values are set
            }
        }
    }

    loadPreviousAssignments = () => {
        const { examination } = this.props;

        if (examination?.assignedTo?.length > 0) {
            const preSelectedIds = [];

            // Collect section IDs and student IDs
            examination.assignedTo.forEach(assignment => {
                // If assignment has no studentIds or empty array, entire section is assigned
                if (!assignment.studentIds || assignment.studentIds.length === 0) {
                    if (assignment.sectionId) {
                        preSelectedIds.push(assignment.sectionId);
                    }
                } else {
                    // Only specific students are assigned, add student IDs
                    preSelectedIds.push(...assignment.studentIds);
                }
            });

            this.setState({ preSelectedIds });
        }
    };

    setDropdownValues = (dropdownsData) => {
        this.setState({
            dropdownsData,
        }, () => {
            // Load data based on dropdown selection
            if (dropdownsData?.branchId && dropdownsData?.classId) {
                this.getAssignmentInfo(
                    dropdownsData.branchId,
                    dropdownsData.boardId,
                    dropdownsData.classId,
                    dropdownsData.sectionId
                );
            }
        });
    }

    getAssignmentInfo = (branchId, boardId, classId, sectionId) => {
        // Only proceed if we have boardId and classId
        if (!boardId || !classId) return;

        this.setState({ isLoading: true });

        const AcademicYear = localStorage.getItem('userAcademicYear');
        const payload = {
            branchId,
            boardId,
            classId,
            sectionId,
            academicYear: AcademicYear
        };

        this.service.post(`${baseUrlAdmin}/fee-structure/assignInfo`, payload, true)
            .then(data => {
                if (data && data.res && data.res.data) {
                    const assignInfo = data.res.data || [];
                    const { examination } = this.props;

                    // Add assignment status to each item
                    const enrichedAssignInfo = assignInfo.map(item => {
                        const enrichedItem = { ...item };

                        // If it's a section (not a student), check if it has assignments
                        if (item.sectionId && !item.user_id) {
                            const sectionAssignment = examination.assignedTo?.find(
                                s => s.sectionId === item.sectionId
                            );

                            if (sectionAssignment) {
                                const studentIds = sectionAssignment.studentIds || [];
                                if (studentIds.length === 0) {
                                    enrichedItem.assignmentStatus = 'All students assigned';
                                    enrichedItem.isAssigned = true; // Mark as assigned for disabling
                                } else {
                                    enrichedItem.assignmentStatus = `${studentIds.length} student${studentIds.length > 1 ? 's' : ''} assigned`;
                                    enrichedItem.isAssigned = true; // Mark as assigned for disabling
                                }
                            }
                        }

                        // If it's a student, check if they're assigned
                        if (item.user_id) {
                            const studentAssigned = examination.assignedTo?.some(assignment => {
                                // Check if student is explicitly in studentIds array
                                if (assignment.studentIds && assignment.studentIds.includes(item.user_id)) {
                                    return true;
                                }
                                // Check if entire section is assigned (empty studentIds array)
                                // and this student belongs to that section
                                if ((!assignment.studentIds || assignment.studentIds.length === 0) &&
                                    assignment.sectionId === item.sectionId) {
                                    return true;
                                }
                                return false;
                            });
                            if (studentAssigned) {
                                enrichedItem.isAssigned = true; // Mark as assigned for disabling
                            }
                        }

                        return enrichedItem;
                    });

                    // Pre-select previously assigned items
                    const { preSelectedIds } = this.state;
                    let preSelected = [];

                    if (preSelectedIds.length > 0) {
                        preSelected = enrichedAssignInfo.filter(item => {
                            // Check if section is selected (entire section assigned)
                            if (item.sectionId && !item.user_id && preSelectedIds.includes(item.sectionId)) {
                                return true;
                            }
                            // Check if individual student is selected
                            if (item.user_id && preSelectedIds.includes(item.user_id)) {
                                return true;
                            }
                            // Check if this is a section row and has assignment status
                            // This means some students in this section are assigned
                            if (item.sectionId && !item.user_id && item.assignmentStatus) {
                                return true;  // Check the section checkbox if it has any assignments
                            }
                            return false;
                        });
                    }

                    // Special case: If we're viewing students in a specific section
                    // and that section has ALL students assigned (studentIds: [])
                    // then select all students in the list
                    if (sectionId && examination?.assignedTo) {
                        const sectionAssignment = examination.assignedTo.find(
                            s => s.sectionId === sectionId
                        );

                        // If section is assigned and studentIds is empty, it means ALL students assigned
                        if (sectionAssignment && (!sectionAssignment.studentIds || sectionAssignment.studentIds.length === 0)) {
                            // Select all students in the current view
                            preSelected = enrichedAssignInfo.filter(item => item.user_id);
                        }
                    }

                    this.setState({
                        categoryAssignInfo: enrichedAssignInfo,
                        selectedStudents: preSelected,
                        selectAll: preSelected.length === enrichedAssignInfo.length && enrichedAssignInfo.length > 0,
                        isLoading: false
                    });
                } else {
                    this.setState({
                        categoryAssignInfo: [],
                        isLoading: false
                    });
                    this.props.toast.current?.show({
                        severity: 'info',
                        summary: 'Info',
                        detail: 'No data available',
                        life: 3000
                    });
                }
            })
            .catch(error => {
                console.error('Error fetching assignment info:', error);
                this.setState({ isLoading: false });
                this.props.toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to fetch data',
                    life: 3000
                });
            });
    }

    onAssignExam = (assignIds, assignType) => {
        const { dropdownsData } = this.state;
        const { examination, boardId, classId } = this.props;

        if (!dropdownsData?.classId) {
            this.props.toast.current?.show({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Please select board, class and branch',
                life: 3000
            });
            return;
        }

        // Build payload
        const payload = {
            examId: examination.examId,
            branchId: dropdownsData.branchId,
            sectionId: dropdownsData.sectionId,
            assignType: assignType, // 'sections' or 'users'
            assignIds: assignIds
        };

        this.setState({ isLoading: true });

        this.service.post(`${baseUrlAdmin}/subjective-examinations/assign-to-students`, payload, true)
            .then(res => {
                const data = res?.data || res;
                if (data && data.status === true && data.res?.success) {
                    this.props.toast.current?.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: data.res.message || 'Examination assigned successfully',
                        life: 3000
                    });
                    this.setState({ isLoading: false });
                    setTimeout(() => {
                        this.props.onHide();
                    }, 1000);
                } else {
                    this.setState({ isLoading: false });
                    this.props.toast.current?.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: data?.res?.message || 'Failed to assign examination',
                        life: 3000
                    });
                }
            })
            .catch(e => {
                console.error('Error assigning examination:', e);
                this.setState({ isLoading: false });
                this.props.toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to assign examination',
                    life: 3000
                });
            });
    }

    render() {
        const { visible, onHide, examination } = this.props;

        return (
            <Dialog
                visible={visible}
                style={{ width: '96%', height: '96vh' }}
                modal
                blockScroll={true}
                draggable={false}
                closeOnEscape={true}
                dismissableMask={false}
                className='add-a-resource-dialog'
                header={`Assign Examination: ${examination?.examName || ''}`}
                onHide={onHide}
            >
                {this.state.isLoading && <LoadingComponent />}
                <div className="p-5">
                    <div className=''>
                        {/* Info message about assignment restrictions */}
                        <div style={{
                            padding: '12px',
                            marginBottom: '16px',
                            backgroundColor: '#e3f2fd',
                            border: '1px solid #2196f3',
                            borderRadius: '4px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <i className="pi pi-info-circle" style={{
                                fontSize: '1.2rem',
                                color: '#2196f3',
                                marginRight: '10px'
                            }}></i>
                            <span style={{ color: '#1565c0', fontSize: '0.95rem' }}>
                                <strong>Note:</strong> Once assigned, sections/students cannot be unassigned.
                                Already assigned items are disabled and shown in gray.
                            </span>
                        </div>

                        <div className="grid mb-2">
                            <BoardToSectionDDNew
                                setValues={this.setDropdownValues}
                                defaultValues={{
                                    boardId: this.props.boardId || examination?.boardId,
                                    classId: this.props.classId || examination?.classId
                                }}
                                disabledFields={{
                                    board: true,
                                    grade: true,
                                    branch: false,
                                    section: false
                                }}
                                branchData={this.props.branchData}
                            />
                        </div>
                    </div>

                    <DataTable
                        value={this.state.categoryAssignInfo}
                        dataKey={this.state?.dropdownsData?.sectionId ? 'user_id' : this.state?.dropdownsData?.classId ? 'sectionId' : 'classId'}
                        paginator
                        rows={this.state.rowsPerPage}
                        first={this.state.currentPage * this.state.rowsPerPage}
                        onPage={(e) => {
                            this.setState({
                                currentPage: e.page,
                                rowsPerPage: e.rows
                            });
                        }}
                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        responsiveLayout="scroll"
                        sortable
                        selection={this.state.selectedStudents}
                        onSelectionChange={(e) => {
                            this.setState({
                                selectedStudents: e.value,
                                selectAll: false
                            });
                        }}
                        selectAll={this.state.selectAll}
                        onSelectAllChange={(e) => {
                            const allSelected = e.checked;
                            const startIndex = this.state.currentPage * this.state.rowsPerPage;
                            const endIndex = startIndex + this.state.rowsPerPage;
                            const currentPageItems = this.state.categoryAssignInfo.slice(startIndex, endIndex);

                            let newSelection;
                            if (allSelected) {
                                // Add current page items to selection (avoid duplicates)
                                const currentSelectedIds = new Set(this.state.selectedStudents.map(item =>
                                    item.user_id || item.sectionId || item.classId
                                ));
                                const itemsToAdd = currentPageItems.filter(item =>
                                    !currentSelectedIds.has(item.user_id || item.sectionId || item.classId)
                                );
                                newSelection = [...this.state.selectedStudents, ...itemsToAdd];
                            } else {
                                // Remove current page items from selection
                                const currentPageIds = new Set(currentPageItems.map(item =>
                                    item.user_id || item.sectionId || item.classId
                                ));
                                newSelection = this.state.selectedStudents.filter(item =>
                                    !currentPageIds.has(item.user_id || item.sectionId || item.classId)
                                );
                            }

                            this.setState({
                                selectAll: allSelected,
                                selectedStudents: newSelection
                            });
                        }}
                        selectionMode="checkbox"
                        isDataSelectable={(data) => !data.isAssigned}
                        rowClassName={(data) => data.isAssigned ? 'row-disabled' : ''}
                    >
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} exportable={false}></Column>
                        <Column field="branchName" header="Branch Name" className="datatable-cel" sortable />
                        {this.state?.dropdownsData?.branchId && !this.state?.dropdownsData?.sectionId &&
                            <Column
                                field="sectionName"
                                header="Section Name"
                                className="datatable-cel"
                                sortable
                                body={(rowData) => (
                                    <div>
                                        <span>{rowData.sectionName}</span>
                                        {rowData.assignmentStatus && (
                                            <span style={{
                                                marginLeft: '8px',
                                                fontSize: '0.85em',
                                                color: '#666',
                                                fontStyle: 'italic'
                                            }}>
                                                ({rowData.assignmentStatus})
                                            </span>
                                        )}
                                    </div>
                                )}
                            />
                        }
                        {!this.state?.dropdownsData?.sectionId &&
                            <Column field="totalStudents" header="Total Students" className="datatable-cel" sortable />
                        }
                        {this.state?.dropdownsData?.sectionId &&
                            <Column field="username" header="Enrollment ID" className="datatable-cel"
                                body={(rowData) => <p>{(rowData?.username)?.slice(3)}</p>}
                            />
                        }
                        {this.state?.dropdownsData?.sectionId &&
                            <Column field="username" header="Student Name" className="datatable-cel"
                                body={(rowData) => <p>{rowData?.studentName}</p>}
                            />
                        }
                    </DataTable>

                    <div className='flex justify-content-center mb-4 mt-4'>
                        <Button
                            className='submitButtonn w-2'
                            onClick={() => {
                                if (Array.isArray(this.state?.selectedStudents)) {
                                    if (this.state.selectedStudents[0]?.user_id) {
                                        this.onAssignExam(
                                            this.state.selectedStudents.map(i => i.user_id),
                                            "users"
                                        );
                                    } else if (this.state.selectedStudents[0]?.sectionId) {
                                        this.onAssignExam(
                                            this.state.selectedStudents.map(i => i.sectionId),
                                            "sections"
                                        );
                                    } else {
                                        this.onAssignExam(
                                            this.state.selectedStudents.map(i => i.classId),
                                            "grades"
                                        );
                                    }
                                }
                            }}
                        >
                            <p className='submitButtonnText'>Assign</p>
                        </Button>
                        <Button
                            className='cancelButtonn w-2 ml-3'
                            onClick={onHide}
                        >
                            <p className='cancelButtonnText'>Cancel</p>
                        </Button>
                    </div>
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
                <style>{`
                    .row-disabled {
                        background-color: #f5f5f5 !important;
                        opacity: 0.6;
                        cursor: not-allowed !important;
                    }
                    .row-disabled td {
                        color: #999 !important;
                    }
                `}</style>
            </Dialog>
        );
    }
}

const mapStateToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoardsWithoutMeluha'),
    isLoading: state.boardsData.loading,
    branchLevels: state.branchDataLatest?.data?.levels,
    branchData: state.branchDataLatest?.data?.data
});

export default connect(
    mapStateToProps,
    { getBoardsData, getBranchesLatest }
)(Authentication(withRouter(AssignExamToStudents)));
